import React, {useRef, useState} from 'react'
import PropTypes from 'prop-types'
import {Expand, Zoom} from 'hec/assets/icons'
import {Dialog, DialogContent, DialogHeader} from '@/components/ui/dialog'
import {TransformWrapper, TransformComponent} from 'react-zoom-pan-pinch'

export const ExpandContent = ({content, withModal}) => {
    const [modalOpen, setModalOpen] = useState(false)
    const [isZoomEnabled, setIsZoomEnabled] = useState(false)
    const transformRef = useRef(null)

    const enableZoom = () => {
        const currentTransform = transformRef?.current
        if (currentTransform) {
            currentTransform.zoomIn()
            setIsZoomEnabled(true)
        }
    }

    const disableZoom = () => {
        const currentTransform = transformRef?.current
        if (currentTransform) {
            currentTransform.resetTransform()
            setIsZoomEnabled(false)
        }
    }

    const handleExpandClick = () => {
        if (withModal && !modalOpen) {
            setModalOpen(true)
        } else {
            isZoomEnabled ? disableZoom() : enableZoom()
        }
    }

    const handleModalClose = () => {
        setModalOpen(false)
    }

    const renderTransformContent = () => (
        <TransformWrapper
            ref={transformRef}
            initialScale={1}
            centerOnInit={true}
            disabled={!isZoomEnabled}
            pan={{
                lockAxisX: false,
                lockAxisY: false
            }}
            data-testid="expandContent-TransformWrapper"
        >
            <TransformComponent data-testid="expandContent-TransformComponent">
                {content}
            </TransformComponent>
        </TransformWrapper>
    )

    return (
        <>
            <Expand
                className="self-end mb-2 cursor-pointer"
                onClick={handleExpandClick}
                title={isZoomEnabled ? 'Reset Zoom' : 'Zoom In'}
            />
            {withModal && (
                <Dialog
                    open={modalOpen}
                    onOpenChange={handleModalClose}
                    data-testid="expandContent-Dialog"
                >
                    <DialogContent
                        className="pt-9 px-10 max-w-none"
                        data-testid="expandContent-DialogContent"
                    >
                        <DialogHeader data-testid="expandContent-DialogHeader">
                            <div className="flex items-center justify-center relative">
                                {renderTransformContent()}
                                <button
                                    onClick={handleExpandClick}
                                    className="absolute bottom-0 right-0 mt-2 mr-2 p-2 bg-white rounded-full shadow-lg"
                                    title={isZoomEnabled ? 'Reset Zoom' : 'Zoom In'}
                                >
                                    <Zoom className="lg:w-6 lg:h-6 h-4 w-4" />
                                </button>
                            </div>
                        </DialogHeader>
                    </DialogContent>
                </Dialog>
            )}
            {withModal ? content : renderTransformContent()}
        </>
    )
}

ExpandContent.propTypes = {
    content: PropTypes.node.isRequired, // Accepts JSX as the content
    withModal: PropTypes.bool // Boolean to enable modal display
}

export default ExpandContent
